module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/389.68075885.png";